import React from "react";
import { AppShellFallback } from "./AppShellFallback";
import { PublicShellFallback } from "./PublicShellFallback";
import { getContentFallbackForPathname } from "./routeContentFallbackRegistry";

const PUBLIC_PATHS = new Set(["/explore", "/signup"]);

/** RouterProvider fallbackElement: shown while the matched route tree is loading. */
export const RouterFallback: React.FC = () => {
  const pathname = window.location.pathname;
  if (PUBLIC_PATHS.has(pathname)) {
    return <PublicShellFallback />;
  }
  const ContentFallback = getContentFallbackForPathname(pathname);
  return <AppShellFallback ContentFallback={ContentFallback} />;
};
